var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInternetLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 58,
    viewBox: "0 0 63 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8409 46.6591C26.1894 46.6591 23.0379 45.9394 20.3864 44.5C17.75 43.0455 15.7197 40.9773 14.2955 38.2955C12.8864 35.5985 12.1818 32.3939 12.1818 28.6818C12.1818 25.0758 12.8939 21.9242 14.3182 19.2273C15.7424 16.5152 17.75 14.4091 20.3409 12.9091C22.9318 11.3939 25.9848 10.6364 29.5 10.6364C31.9848 10.6364 34.2576 11.0227 36.3182 11.7955C38.3788 12.5682 40.1591 13.7121 41.6591 15.2273C43.1591 16.7424 44.3258 18.6136 45.1591 20.8409C45.9924 23.053 46.4091 25.5909 46.4091 28.4545V31.2273H16.0682V24.7727H36.0682C36.053 23.5909 35.7727 22.5379 35.2273 21.6136C34.6818 20.6894 33.9318 19.9697 32.9773 19.4545C32.0379 18.9242 30.9545 18.6591 29.7273 18.6591C28.4848 18.6591 27.3712 18.9394 26.3864 19.5C25.4015 20.0455 24.6212 20.7955 24.0455 21.75C23.4697 22.6894 23.1667 23.7576 23.1364 24.9545V31.5227C23.1364 32.947 23.4167 34.197 23.9773 35.2727C24.5379 36.3333 25.3333 37.1591 26.3636 37.75C27.3939 38.3409 28.6212 38.6364 30.0455 38.6364C31.0303 38.6364 31.9242 38.5 32.7273 38.2273C33.5303 37.9545 34.2197 37.553 34.7955 37.0227C35.3712 36.4924 35.803 35.8409 36.0909 35.0682L46.2955 35.3636C45.8712 37.6515 44.9394 39.6439 43.5 41.3409C42.0758 43.0227 40.2045 44.3333 37.8864 45.2727C35.5682 46.197 32.8864 46.6591 29.8409 46.6591Z",
    fill: "url(#paint0_linear_31_42)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_31_42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8409 40.9737C-7.41792 42.2547 30.619 -3.68701 44.0001 14.0979",
    stroke: "#FFD01E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_31_42",
    x: 3.00049,
    y: 9,
    width: 45.9995,
    height: 40.9999,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_31_42"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_31_42",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31_42",
    x1: 53.4,
    y1: 16.8571,
    x2: 44.0861,
    y2: -9.5997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1989FA",
    stopOpacity: 0.970833
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857292,
    stopColor: "#0051A3",
    stopOpacity: 0.990034
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1989FA",
    stopOpacity: 0.41
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_42"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 58,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternetLogo);
export default __webpack_public_path__ + "static/media/internet-logo.194dcf5faf03c30fb6a8a336c9bbd535.svg";
export { ForwardRef as ReactComponent };